import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import { FnrOverlayTitle } from "UI/FnrOverlay";
import { SharedResizingChild } from "UI/SharedResizingArea";

import RelationshipLine from "./RelationshipLine";

RelationshipsConfirmation.propTypes = {
  householdRelationships: PropTypes.array,
  relationshipUser: PropTypes.object,
  paymentMethodsUnshared: PropTypes.bool,
  hideHelpText: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default function RelationshipsConfirmation({
  householdRelationships,
  relationshipUser,
  paymentMethodsUnshared,
  hideHelpText,
  readOnly,
}) {
  const [paymentsUnsharedRelLine, setPaymentsUnsharedRelLine] = useState(false);
  const showUnsharedPaymentsMsg =
    paymentMethodsUnshared || paymentsUnsharedRelLine;

  return (
    <SharedResizingChild>
      <Wrapper>
        <FnrOverlayTitle>{relationshipUser.fname} is...</FnrOverlayTitle>
        {householdRelationships.map((relationship, index) => (
          <RelationshipLine
            {...relationship}
            mainUserID={relationshipUser.ID}
            relationshipUserLastName={relationshipUser.lname}
            key={index}
            readOnly={readOnly}
            onPaymentMethodsUnshared={() => setPaymentsUnsharedRelLine(true)}
          />
        ))}

        {hideHelpText ? null : (
          <HelpText>
            This is a summary of the rest of {relationshipUser.fname + "'s"}{" "}
            relationships in the household. If anything looks off, click the
            arrow next to any of them to change them.
          </HelpText>
        )}

        {showUnsharedPaymentsMsg ? (
          <UnsharedPayments>
            For your security, we have unshared your saved payment methods. To
            re-share, please visit the Wallet tab of your profile.
          </UnsharedPayments>
        ) : null}
      </Wrapper>
    </SharedResizingChild>
  );
}

const Wrapper = styled.div`
  width: 348px;
  max-height: 700px;
  overflow: auto;

  @media screen and (max-width: 420px) {
    width: 80vw;
  }
`;
const HelpText = styled.div`
  color: #384a5d;
  font-size: 14px;
  padding-top: 12px;
  border-top: 1px solid #bec3c7;
`;

const UnsharedPayments = styled.div`
  color: #384a5d;
  font-size: 14px;
  padding-top: 12px;
  font-style: italic;
`;
